import { render, staticRenderFns } from "./ReferenceConfiguration.vue?vue&type=template&id=00c0fc88&"
import script from "./ReferenceConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ReferenceConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports